import React from "react";
import { Route, Routes } from "react-router-dom";
import SharePage from "./pages/SharePage";
import GiftTable from "./pages/GiftTable";
import CartPage from "./pages/CartPage"; // Import the CartPage component
import MainLayout from "../../layouts/MainLayout";
import DedicationPage from "./pages/DedicationPage";
import PaymentPreviewPage from "./pages/PaymentPreviewPage";
import GuestPaymentPage from "./pages/GuestPaymentPage/GuestPaymentPage";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import GuestPaymentSuccess from "./pages/GuestPaymentSuccess";

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

const GuestsRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/share/:id" element={<SharePage />} />
      <Route
        path="/gifttable/:id"
        element={
          <MainLayout>
            <GiftTable />
          </MainLayout>
        }
      />
      <Route
        path="/gifttable/cart/:id"
        element={
          <MainLayout>
            <CartPage />
          </MainLayout>
        }
      />
      <Route
        path="/checkout/dedication/:id"
        element={
          <MainLayout>
            <DedicationPage />
          </MainLayout>
        }
      />{" "}
      <Route
        path="/checkout/preview/:id"
        element={
          <MainLayout>
            <PaymentPreviewPage />
          </MainLayout>
        }
      />
      <Route
        path="/checkout/payment/:id"
        element={
          <MainLayout>
            <Elements stripe={stripePromise}>
              <GuestPaymentPage />
            </Elements>
          </MainLayout>
        }
      />{" "}
      <Route
        path="/checkout/success/:id"
        element={
          <MainLayout>
            <GuestPaymentSuccess />
          </MainLayout>
        }
      />
    </Routes>
  );
};

export default GuestsRouter;
